import React, {useEffect, useState} from "react";
import FeatherIcon from "feather-icons-react";

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Top: 0 takes us all the way back to the top of the page
  // Behavior: smooth keeps it smooth!
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    // Button is displayed after scrolling for 500 pixels
    const toggleVisibility = () => {
      if (window.pageYOffset > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

    return <div
        className={`back-to-top ${isVisible ? "active" : "hide"}`}
        onClick={scrollToTop}
    >
      <FeatherIcon icon="arrow-up"/>
    </div>
}

export default BackToTopButton